import { createIcon } from '@chakra-ui/react'

export const PencilIcon = createIcon({
  displayName: 'PencilIcon',
  viewBox: '0 0 36 36',
  path: (
    <svg xmlns="http://www.w3.org/2000/svg">
      <g clipPath="url(#clip0_838_8)">
        <mask
          id="path-1-outside-1_838_8"
          maskUnits="userSpaceOnUse"
          x="9.05519"
          y="6.78925"
          width="17.9104"
          height="23.3721"
          fill="black"
        >
          <rect
            fill="white"
            x="9.05519"
            y="6.78925"
            width="17.9104"
            height="23.3721"
          />
          <path d="M25.2428 14.6402L16.1744 24.7995C16.1141 24.8672 16.0385 24.9136 15.9574 24.9383L11.1109 26.412C10.7694 26.5154 10.4386 26.2215 10.5013 25.8747L11.3879 20.9266C11.4049 20.8316 11.4497 20.7482 11.5124 20.6835L20.5688 10.5376C21.4602 9.53921 23.0073 9.44663 24.0201 10.3356L25.026 11.2188C26.0368 12.1059 26.1358 13.6398 25.2428 14.6402ZM24.3946 11.9237L23.8939 11.4832C23.3936 11.0439 23.0408 10.6305 22.309 10.6733C21.9271 10.6957 21.5542 10.8617 21.2826 11.166L12.3029 21.2247L11.5761 25.2815L15.5484 24.0738L24.5276 14.0145C25.0696 13.4075 25.0116 12.4655 24.3946 11.9237Z" />
        </mask>
        <path
          d="M25.2428 14.6402L16.1744 24.7995C16.1141 24.8672 16.0385 24.9136 15.9574 24.9383L11.1109 26.412C10.7694 26.5154 10.4386 26.2215 10.5013 25.8747L11.3879 20.9266C11.4049 20.8316 11.4497 20.7482 11.5124 20.6835L20.5688 10.5376C21.4602 9.53921 23.0073 9.44663 24.0201 10.3356L25.026 11.2188C26.0368 12.1059 26.1358 13.6398 25.2428 14.6402ZM24.3946 11.9237L23.8939 11.4832C23.3936 11.0439 23.0408 10.6305 22.309 10.6733C21.9271 10.6957 21.5542 10.8617 21.2826 11.166L12.3029 21.2247L11.5761 25.2815L15.5484 24.0738L24.5276 14.0145C25.0696 13.4075 25.0116 12.4655 24.3946 11.9237Z"
          fill="black"
        />
        <path
          d="M25.2428 14.6402L16.1744 24.7995C16.1141 24.8672 16.0385 24.9136 15.9574 24.9383L11.1109 26.412C10.7694 26.5154 10.4386 26.2215 10.5013 25.8747L11.3879 20.9266C11.4049 20.8316 11.4497 20.7482 11.5124 20.6835L20.5688 10.5376C21.4602 9.53921 23.0073 9.44663 24.0201 10.3356L25.026 11.2188C26.0368 12.1059 26.1358 13.6398 25.2428 14.6402ZM24.3946 11.9237L23.8939 11.4832C23.3936 11.0439 23.0408 10.6305 22.309 10.6733C21.9271 10.6957 21.5542 10.8617 21.2826 11.166L12.3029 21.2247L11.5761 25.2815L15.5484 24.0738L24.5276 14.0145C25.0696 13.4075 25.0116 12.4655 24.3946 11.9237Z"
          stroke="black"
          strokeWidth="0.6"
          mask="url(#path-1-outside-1_838_8)"
        />
        <line
          x1="13.367"
          y1="20.4658"
          x2="16.367"
          y2="23.4658"
          stroke="black"
          strokeWidth="1.5"
        />
      </g>
      <defs>
        <clipPath id="clip0_838_8">
          <rect
            width="18.1594"
            height="21.2311"
            fill="white"
            transform="translate(11.2383 6) rotate(11.5151)"
          />
        </clipPath>
      </defs>
    </svg>
  ),
})
